export default "__VITE_ASSET__cdf31aec__"